/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Compare_ToggleInputs */

const en_usage_compare_toggle = /** @type {(inputs: Usage_Compare_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare with previous period`)
};

const fr_usage_compare_toggle = /** @type {(inputs: Usage_Compare_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparer avec la période précédente`)
};

const de_usage_compare_toggle = /** @type {(inputs: Usage_Compare_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleich mit dem vorherigen Zeitraum`)
};

const it_usage_compare_toggle = /** @type {(inputs: Usage_Compare_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta con il periodo precedente`)
};

const ru_usage_compare_toggle = /** @type {(inputs: Usage_Compare_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По сравнению с предыдущим периодом`)
};

const es_usage_compare_toggle = /** @type {(inputs: Usage_Compare_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar con el período anterior`)
};

const zh_cn2_usage_compare_toggle = /** @type {(inputs: Usage_Compare_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与上期相比`)
};

const ja_usage_compare_toggle = /** @type {(inputs: Usage_Compare_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前期との比較`)
};

const hi_usage_compare_toggle = /** @type {(inputs: Usage_Compare_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछली अवधि से तुलना करें`)
};

const pt_pt2_usage_compare_toggle = /** @type {(inputs: Usage_Compare_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar com o período anterior`)
};

/**
* | output |
* | --- |
* | "Compare with previous period" |
*
* @param {Usage_Compare_ToggleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_compare_toggle = /** @type {((inputs?: Usage_Compare_ToggleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Compare_ToggleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_compare_toggle(inputs)
	if (locale === "de") return de_usage_compare_toggle(inputs)
	if (locale === "it") return it_usage_compare_toggle(inputs)
	if (locale === "ru") return ru_usage_compare_toggle(inputs)
	if (locale === "es") return es_usage_compare_toggle(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_compare_toggle(inputs)
	if (locale === "ja") return ja_usage_compare_toggle(inputs)
	if (locale === "hi") return hi_usage_compare_toggle(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_compare_toggle(inputs)
	return en_usage_compare_toggle(inputs)
});